import LandingColumn from './landing-column';

export default LandingColumn;